var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_img",
    "data-name": "vuesax/bulk/img",
    transform: "translate(-492 -252)",
    opacity: 0.503
  }, /*#__PURE__*/React.createElement("g", {
    id: "img"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20,5.81V12H15.92a2.193,2.193,0,0,1-1.77-1.07L13.11,8.96c-.28-.53-.68-.5-.9.05l-2.3,5.81c-.25.65-.67.65-.93,0L7.84,11.94a2.151,2.151,0,0,0-1.86-1.27L0,10.7V5.81C0,2.17,2.17,0,5.81,0h8.38C17.83,0,20,2.17,20,5.81Z",
    transform: "translate(494 254)",
    fill: "#292d32",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M20,5.611V3.421H15.92a2.193,2.193,0,0,1-1.77-1.07L13.11.381c-.28-.53-.68-.5-.9.05l-2.3,5.81c-.25.65-.67.65-.93,0L7.84,3.361a2.151,2.151,0,0,0-1.86-1.27L0,2.121v3.49c0,3.58,2.1,5.74,5.63,5.8.11.01.23.01.34.01h8c.15,0,.3,0,.44-.01C17.92,11.331,20,9.181,20,5.611Z",
    transform: "translate(494 262.579)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M.03,0V3.31C.01,2.99,0,2.65,0,2.3V0Z",
    transform: "translate(493.97 264.7)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(492 252)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(499 260)",
    fill: "#282c30"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholder);
export default __webpack_public_path__ + "static/media/img-placeholder.d39558c4eba00523a6d86fb493f68430.svg";
export { ForwardRef as ReactComponent };